module.exports = __webpack_public_path__ + "static/Logo_6-d66c68b41cbfdae643757adfa0f2b856.png";